import {styled, Tooltip, tooltipClasses, TooltipProps} from "@mui/material";

export const BlackTooltip = styled(({className, ...props}: TooltipProps) => (
    <Tooltip {...props} arrow placement="top" classes={{popper: className}}>
        {props.children}
    </Tooltip>
))(({theme}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        padding: "8px 12px",
        backgroundColor: "#1B2229",
        color: "#FFFFFF",
        boxShadow: theme.shadows[1],
        borderRadius: 8,
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: 12,
        lineHeight: "16px",
        textAlign: "center",
        opacity: 1,
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: "#1B2229",
    },
}));
